import { v4 } from 'uuid';
import { detectOS } from './detectOS.js';
import { getCurrentDate } from './getCurrentDate.js';

function generateUserInfo() {
  return {
    deviceId: v4(),
    os: detectOS(),
    creationDate: getCurrentDate()
  };
}

export { generateUserInfo };
